export default __webpack_public_path__ + "static/media/LogoINTEL_2.242e0847.png";